import type { SVGProps } from "react";

export const ExpandCollapseCaret = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.99997 11.03L3.32947 6.32999L4.17997 5.48049L7.99997 9.29949L11.82 5.47949L12.6705 6.32999L7.99997 11.03Z"
        fill="currentColor"
      />
    </svg>
  );
};
